import PropTypes from "prop-types";
import ProgressBarTick from "/public/images/icons/progressBarTick.svg?react";
import { useThemeContext } from "../../context/themeContext";

export default function ProgressBar({ step, complete = false, overrideTotalSteps }) {
  if (!step) {
    return "No step provided";
  }

  const { theme } = useThemeContext();
  const stepInt = parseInt(step);
  const totalSteps = overrideTotalSteps ? overrideTotalSteps : 5;
  const barProgress = (((stepInt - 1) / overrideTotalSteps ? (overrideTotalSteps - 1) : 4) * 100).toString() + "%";

  return (
    <div className="max-w-[341px] w-full mx-auto relative">
      <div className="relative">
        <div className={`w-full max-w-[341px] h-[2px] bg-[#E3E3E3]`}></div>
        <div
          style={{
            width: barProgress,
          }}
          className={`
            absolute top-0 left-0 h-full max-w-full
            ${theme === "staff" ? "bg-sportsBlue" : "bg-sportsYellow"}
          `}
        ></div>
      </div>

      <div className="absolute w-[calc(100%+16px)] h-full -mx-2 top-1/2 -translate-y-1/2 flex justify-between items-center">
        {[...Array(totalSteps)].map((_, index) => (
          <div
            key={index}
            className={`
                            ${index + 1 > stepInt ? "bg-[#E3E3E3]" : ""}
                            ${
                              index + 1 < stepInt || complete
                                ? theme === "staff" ? "bg-sportsBlue" : "bg-sportsYellow"
                                : ""
                            }
                            ${
                              index + 1 === stepInt && !complete
                                ? "bg-sportsYellow/20 mx-[3px] w-[10px] h-[10px]"
                                : "w-4 h-4"
                            }
                            rounded-full flex items-center justify-center
                        `}
          >
            {index + 1 === stepInt && !complete && (
              <div className={
                `w-[10px] h-[10px] rounded-full relative
                ${theme === "staff" ? "bg-sportsBlue" : "bg-sportsYellow"}
              `}>
                <div className="w-[10px] h-[10px] bg-sportsYellow/20 rounded-full absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 animate-scale" />
              </div>
            )}
            {(index + 1 < stepInt || complete) && (
              <ProgressBarTick className="w-[6px] h-[5px]" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  step: PropTypes.number.isRequired,
  complete: PropTypes.bool,
};
